<template>
  <div
    class="empty-page d-flex flex-column align-items-center justify-content-center"
  >
    <div
      v-if="displayIcon"
      class="icon-wrapper d-flex align-items-center justify-content-center"
    >
      <i-icon
        :symbol="displayIcon"
        :size="48"
        :colour="palette['light-primary-110']"
      ></i-icon>
    </div>
    <h5 class="i-text-heading-4 i-text-neutral-120 i-mb-4 i-mt-8">
      {{ displayTitle }}
    </h5>
    <p class="message i-text-body-2 i-text-neutral-110 text-center">
      {{ displayMessage }}
      <a
        v-if="link"
        rel="noopener"
        class="i-link"
        :href="displayLink"
        target="_blank"
        >Learn more</a
      >
    </p>
    <i-button
      v-if="btnClick"
      class="i-mt-11"
      :text="btnText"
      data-testid="empty-page-cta-button"
      size="lg"
      v-read-only-check
      :disabled="btnDisabled"
      @button-click="btnClick()"
    ></i-button>
  </div>
</template>

<script>
import { iButton, iIcon } from '@inscribe/signal';
import { sanitizeUrl } from '@braintree/sanitize-url';
import palette from '@inscribe/signal/dist/palette';

export default {
  components: {
    'i-icon': iIcon,
    'i-button': iButton,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '',
    },
    btnClick: {
      type: Function,
      default: undefined,
    },
    btnDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      displayIcon: this.icon,
      displayTitle: this.title,
      displayMessage: this.message,
      displayLink: sanitizeUrl(this.link),
      palette,
    };
  },
  mounted() {
    if (this.type === 'permission') {
      this.displayIcon = 'large-lock';
      this.displayTitle = 'Permission Required';
      this.displayMessage =
        'You do not have sufficient permissions to access this page. Please ask your team admin to give you access.';
    }
  },
};
</script>

<style lang="scss" scoped>
.empty-page {
  min-height: 400px;
  max-width: 500px;
  margin: auto;
  text-align: center;

  .icon-wrapper {
    width: 128px;
    height: 128px;
    border-radius: 64px;
    background-color: $light-primary-20;
  }
}
</style>
